import React from 'react';
import { useNavigate } from 'react-router-dom'; // Agar React Router use kar rahe ho
import { FaArrowRight } from 'react-icons/fa';
import './StartProjectSection.scss';

const StartProjectSection = () => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate('/contact-us');
  };

  return (
    <section className="sp-ref-section">
      <div className="sp-ref-container">
        <div className="sp-ref-card">
          <div className="sp-ref-content">
            <span className="sp-ref-tag">Ready to Scale?</span>
            
            <h2 className="sp-ref-title">
              Innovating The Future of <br />
              <span>Software Solutions</span>
            </h2>
            
            <p className="sp-ref-desc">
           Econsignment Soft is a specialized and results-driven software development company. 
              We believe in crafting innovative, high-quality digital solutions that empower 
              businesses to thrive in the modern era.
            </p>
            
            <div className="sp-ref-action">
              {/* Button with smooth pulse and link */}
              <button className="sp-ref-btn" onClick={handleRedirect}>
                Start Your Project
                <FaArrowRight className="sp-ref-arrow" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StartProjectSection;